
import { createSlice} from "@reduxjs/toolkit";
const clientCsv = createSlice({
  name: 'clientPortalCsv',
      initialState:{
        data:null,
        loading:false,
        error:null,
    },
  reducers: {
    fetchData: (state) => {
      state.loading = true;
    },
    fetchDataSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchDataError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    reSetData:()=>{
      return {
        data:null,
        loading:false,
        error:null,
    }
    }
  },
});
export const { fetchData, fetchDataSuccess, fetchDataError,reSetData } = clientCsv.actions;
export default clientCsv.reducer;